import React from 'react'
import '../css/BisharatMain.css';
import translate from '../languages/translate';

function DonationSuccess() {
    return (
        <div className="page-not-found">
           <h1> {translate("thanks-for-donation")} </h1>
           <a href="/" className="btn">{translate("back-to-main")} </a>
        </div>
    )
}

export default DonationSuccess
